export const homeFaqItems = [
  {
    question: "What is KunbiCaste.com Maratha Vadhu Var Search?",
    answer:
      "KunbiCaste.com Maratha Vadhu Var search is an online brand of 'Marathi Vadhu Var Suchak', which showcase well educated Kunbi Maratha records of Vadhu Var on one click. This dedicated service is simply a free classified of 'Marathi Vadhu Var Suchak'.",
  },
  {
    question: "What are the benefits of KunbiCaste.com Vadhu Var Search?",
    answer:
      "Well educated Kunbi Caste Maratha Vadhu Var can search and view verified profiles on just a single click with a short information with profile photo.",
  },
  {
    question: "How could I add my profile on KunbiCaste.com Vadhu Var list?",
    answer:
      "Very simple! You just have to register free through the 'MarathiVadhuVarSuchak.com' app. Then your Kunbi Maratha records of profile will be displayed on KunbiCaste.com too.",
  },
  {
    question:
      "How could I see the full profile, viewed on KunbiCaste.com search?",
    answer:
      "You have to register free through 'MarathiVadhuVarSuchak.com' mobile app and where you can see the full profile, which was viewed on KunbiCaste.com Vadhu Var search result.",
  },
  {
    question: "Can I use KunbiCaste.com Vadhu Var search for free?",
    answer:
      "Yes! KunbiCaste.com Maratha Vadhu Var search is free. The 'MarathiVadhuVarSuchak.com' mobile app also allowed a free online registration.",
  },
] as const;
